// Pure lead search for the Log Touchpoint combobox (BUG-019). Matches the typed
// query against the business name and contact person, case-insensitively. Empty
// query returns the list unchanged (so the dropdown shows everything on focus).
export function searchLeads(leads, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return leads || [];
  return (leads || []).filter((l) => (
    (l.businessName || '').toLowerCase().includes(q)
    || (l.contactPerson || '').toLowerCase().includes(q)
  ));
}

// Display label for a lead's last touch date in the picker.
export function lastVisitLabel(ms) {
  if (typeof ms !== 'number' || !Number.isFinite(ms)) return 'Never';
  return new Date(ms).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
